<div class="third-step-container">
  <h2>Share your professional background and what motivates you.</h2>

  <!-- LinkedIn Profile Card -->
  <div class="forms" [formGroup]="form">
    <h3>Share your LinkedIn profile</h3>
    <div
      class="nz-block-input"
      [ngClass]="{
        error:
          form.controls['linkedInUrl'].status === 'INVALID' &&
          form.controls['linkedInUrl'].touched
      }"
    >
      <input nz-input type="text" placeholder="Paste your LinkedIn profile URL" formControlName="linkedInUrl" />
    </div>
  </div>

  <!-- Motivation Card -->
  <div class="forms" [formGroup]="form">
    <h3>Why do you want to join Cloudstaff?</h3>
    <div class="nz-block-input">
      <textarea 
        nz-input 
        [nzAutosize]="{ minRows: 3, maxRows: 6 }" 
        placeholder="Share what excites you about Cloudstaff and being part of our team."
        formControlName="whyJoinToCompany">
      </textarea>
    </div>
  </div>

</div>